<template>
  <div id="prompt">

    <div id="prevPrompt"></div>

    <!-- TODO: View random un-responded prompt? -->
    <!-- TODO: Hide head/footer when responding? -->
    <div id="promptContent">
      <div class="loading" v-if="isLoaded == false">
        <h2>Generating a new prompt. This may take a few moments.</h2>
        <p><img src="loading.gif" alt="loading..."></p>
      </div>
      <div v-else>

          <div v-if="seePrompt==false && seeResponse==false">
            <h2>Generate a Prompt</h2>
            <h3>This prompt is generated on demand using OpenAI's GPT-3 machine learning system based on existing <em>Under The Dog Star</em> writing prompts.</h3>
            <h3>You will have 15 seconds to consider the prompt. Once the writing field is accessible, you will have 5 minutes complete your response before your work is saved. Clicking submit or navigating away from this window will save your work before the full time has elapsed.</h3>
            <br>
            <p><a href="#" class="btnLink" v-on:click.prevent="showPrompt">Show Prompt</a></p>
          </div>
          <div v-else class="promptText">
            <h3>Prompt:</h3>
            <p>{{ currentPrompt.prompt }}</p>
          </div>

        <div v-if="seeForm!=true && seeResponse!=true" class="formPlaceholder"></div>

        <form id="newResponse" v-if="seeForm==true" v-on:submit.prevent="newResponse">
          <h3>Write your five minute response:</h3>
          <textarea name="response" v-model="response"></textarea>
          <input type="submit" class="submitResponse" value="Submit Response">
        </form>

        <div v-if="seeResponse==true">
          <h3>Your response:</h3>
          <p class="promptText">{{currentPrompt.response}}</p>

          <div class="share">

              <form v-if="responseEmailed==false" v-on:submit.prevent="emailResponse" class="emailForm">
                <label>Email your response:</label><br>
                <p class="error" v-if="showEmailError==true">Please enter a valid email address</p>
                <input v-model="emailAddress" placeholder="address@email.com" type="text" name="email" value="">
                <input type="submit" value="Send Email">
              </form>
              <p v-else>Email Sent</p>

            <!-- TODO: Show url for sharing -->
            <p>This is your unique response URL. Copy it to share your response.</p>
            <span class="responseURL">{{responseURL}}</span>
          </div>

        </div>
      </div>
    </div>

    <div id="nextPrompt"></div>

  </div>
</template>

<script type="text/javascript">
  import api from "../services/DataService";

  export default {
    props: ['user'],
    data: function () {
      return {
        currentPrompt: {},
        seePrompt: false,
        seeForm: false,
        seeResponse: false,
        isLoaded: false,
        emailAddress: "",
        responseEmailed: false,
        timerExpired: false,
        showEmailError: false,
        promptIndex: 0,
        response: "",
        responseTimer: undefined,
        thinkTimer: undefined
      }
    },
    computed: {
      responseURL: function() {
        return process.env.VUE_APP_BASE_URL+"/#response/"+this.currentPrompt._id+"?gen=true";
      }
    },
    created: function() {
      this.fetchData();
    },
    beforeRouteUpdate (to, from, next) {
      this.autoSubmit(to, from, next);
    },
    beforeRouteLeave (to, from, next) {
      this.autoSubmit(to, from, next);
    },
    methods: {
      autoSubmit (to, from, next) {
        if (this.seePrompt && !this.showResponse()) {
          const answer = window.confirm('Your response, even if empty or unfinished, will be saved when you leave this page.')
          if (answer) {
            this.newResponse();
            next()
          } else {
            next(false)
          }
        } else {
          next()
        }
      },
      preventNav(event) {
        if (!this.seePrompt) return
        event.preventDefault()
        event.returnValue = ""
      },
      showResponse () {
        if (this.currentPrompt.response) {
          return true;
        } else {
          return false;
        }
      },
      fetchData () {
        this.isLoaded = false;

        this.responseSubmitted = false;
        this.seePrompt = false;
        this.seeForm = false;

        api.getGenPrompt()
          .then(response => {
            let p = response.data.data.text;
            console.log(p);

            this.currentPrompt.prompt = p;
            this.isLoaded = true;
          })
          .catch(e => {
            console.log(e);
          });
      },
      thinkTimerDone () {
        this.seeForm = true;
        clearInterval(this.thinkTimer);
        this.responseTimer = setInterval(this.responseTimerDone, 300000);
      },
      responseTimerDone () {
        // TODO: Change color when 30 seconds left
        this.seeForm = false;
        // Submit when timer runs out
        clearInterval(this.responseTimer);
        this.newResponse();
      },
      showPrompt () {
        this.seePrompt = true;
        //WARN WHEN LEAVING PAGE
        this.thinkTimer = setInterval(this.thinkTimerDone, 15000);
        if (!this.seeResponse) {
          window.addEventListener("beforeunload", this.preventNav)
        }
      },
      newResponse () {
        clearInterval(this.responseTimer);
        this.timerExpired = false;
        this.seeForm = false;

        api.createGenprompt({response: this.response, prompt: this.currentPrompt.prompt, user_session: this.user.uuid})
          .then(response => {
            console.log("Response Saved!", response);
            this.currentPrompt.response = response.data.data.response;
            this.currentPrompt._id = response.data.data._id;
            window.removeEventListener("beforeunload", this.preventNav);
            this.response = "";
            this.seeResponse = true;
          })
          .catch(e => {
            console.log(e);
          });
      },
      validEmail: function (email) {
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      },
      emailResponse () {
        // email your response
        const emailMsg = {to: this.emailAddress, response: this.currentPrompt.response, prompt: this.currentPrompt.prompt, url: this.responseURL};
        if (this.emailAddress != "" && this.validEmail(this.emailAddress)) {
          api.emailResponse(emailMsg)
            .then(() => {
              this.responseEmailed = true;
            })
            .catch(e => {
              console.log(e);
            })
        } else {
          //show email error
          this.showEmailError = true;
        }
      }
    }
  }
</script>

<style media="screen" src="../styles/prompt.css"></style>
